export enum WorkflowNodeType {
    SYSTEM_NODE,
    PROJECT_LABEL_NODE,
    PROJECT_LABEL_TEMPLATE_NODE,
}
